import Icon from '../../../components/AppIcon';

const SecurityFeatures = () => {
  const features = [
    {
      icon: 'Shield',
      text: 'Autenticação segura com Active Directory'
    },
    {
      icon: 'Lock',
      text: 'Criptografia de dados sensíveis'
    },
    {
      icon: 'FileCheck',
      text: 'Auditoria completa de acessos'
    }
  ];

  return (
    <div className="mt-8 pt-6 border-t border-border">
      <div className="space-y-3">
        {features?.map((feature, index) => (
          <div key={index} className="flex items-center gap-3">
            <div className="w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
              <Icon name={feature?.icon} size={16} color="var(--color-primary)" />
            </div>
            <p className="text-xs text-muted-foreground">{feature?.text}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SecurityFeatures;